import axios from "axios";
import { LOGIN_ACTIONS } from "../constants/action-types";

export const login = (email, password) => {
  return async (dispatch) => {
    dispatch({ type: LOGIN_ACTIONS.TOKEN_LOADING });

    await axios
      .post(process.env.REACT_APP_API_URL + process.env.REACT_APP_VERSION + "/users/login", {
        email,
        password,
      })
      .then((response) => {
        const tokenToSave = "Bearer " + response.data.accessToken;
        if (response.data.user.groupId === 3 || response.data.user.groupId === 4) {
          dispatch({
            type: LOGIN_ACTIONS.TOKEN_ERROR,
            payload: {
              message: "Forbidden",
              code: 30,
            },
          });

        } else {
          dispatch({
            type: LOGIN_ACTIONS.TOKEN_LOADED,
            payload: { token: tokenToSave, user: response.data.user },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: LOGIN_ACTIONS.TOKEN_ERROR,
          payload: {
            message: err.response.data.error.message,
            code: err.response.data.error.code,
          },
        });
      });
  };
};
export const logout = () => {
  return (dispatch) => {
    dispatch({ type: LOGIN_ACTIONS.LOGOUT });
  };
};
